import { render } from "./vue-number-format.vue?vue&type=template&id=95b89e2c"
import script from "./vue-number-format.vue?vue&type=script&lang=js"
export * from "./vue-number-format.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/vue-number-format/vue-number-format/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__